var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.length)?_c('div',[_c('LineChart',{attrs:{"data":_vm.chartData,"options":_vm.chartOptions,"width":450,"height":300}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }